'use client'

import { Instrument } from '@lyra/web/constants/instruments'
import { MarketId } from '@lyra/web/constants/markets'
import React from 'react'

import OptionsChainSection from '../../../containers/trade/OptionsChainSection'

type Props = {
  marketId: MarketId
  instruments: Instrument[]
}

export default function OptionsPageHelperDesktop({ marketId, instruments }: Props) {
  return (
    <OptionsChainSection
      height="100%"
      marketId={marketId}
      instruments={instruments}
      noBottomPadding
    />
  )
}
